import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { PerformanceService } from '../performance.service';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '@app/user/user.service';
import { AuthenticationService } from '@app/_services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { queueList } from '@app/_models/queue-list';
import { NgbCalendar, NgbDateParserFormatter, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from '@app/_shared/date-formatter.service';
import { CustomDateAdapterService } from '@app/_services/custom-date-adapter.service';

@Component({
  selector: 'app-compare',
  templateUrl: './compare.component.html',
  styleUrls: ['./compare.component.less'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomDateAdapterService },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ]
})
export class CompareComponent implements OnInit {
  form: FormGroup;
  executionStatuses: any;
  userProjects: any;
  projectUsers: any;
  userData: any;
  queueData: any;
  testCasesList = [];
  loadTestTypes = [];
  // loadTestType;
  openFilter: boolean = false;
  locations = [];
  startdate: any;
  enddate: any;
  pageSize = 15;
  previousPage: any;
  page = 1;
  queryParamsData = {
    page: 1,
    size: 15,
    // loadType: "",
  }
  moreData = true;

  constructor(
    private titleService: Title,
    private toastr: ToastrService,
    private performanceService: PerformanceService,
    private userService: UserService,
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    public calendar: NgbCalendar,
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Perf | Compare');
    this.executionStatuses = JSON.parse(localStorage.getItem('about')).executionStatuses.filter(item => (item === "PASSED" || item == "FAILED"));
    this.loadTestTypes = JSON.parse(localStorage.getItem('about')).loadTestTypes;
    this.locations = JSON.parse(localStorage.getItem('about')).executionLocations.map(loc => loc.location);

    this.userData = this.authService.currentUserValue;
    this.startdate = this.calendar.getToday();
    this.enddate = this.calendar.getToday();
    this.getUserProject();
    this.setSearchForm();

    this.route.queryParams.subscribe((params: any) => {
      this.getQueue(params);
    });
  }

  setParamsVal(params: any) {
    if (params.loadTestType) this.form.get('loadTestType').setValue(params.loadTestType);
    if (params.projectIds) {
      this.form.get('projectIds').setValue(parseInt(params.projectIds));
      this.getProjectRelatedData();

      if (params.testCaseId) {
        this.form.get('testCaseId').setValue(parseInt(params.testCaseId));
      };
      /* Setting the users */
      if (params.userIds) {
        let users = [];
        if (Array.isArray(params.userIds)) {
          users = params.userIds.map((val: string) => {
            return parseInt(val, 10);
          });
        } else {
          const userId = parseInt(params.userIds, 10);
          users.push(userId);
        }
        this.form.get('userIds').setValue(users)
      }
    }
    if (params.executionStatus) this.form.get('executionStatus').setValue(params.executionStatus);
    if (params.location) {
      this.form.get('location').setValue(params.location);
      this.setLocation();
    }
    if (params.startDate) this.form.get('startDate').setValue(params.startDate);
    if (params.endDate) this.form.get('endDate').setValue(params.endDate);
  }

  setSearchForm() {
    this.form = new FormGroup({
      loadTestType: new FormControl(),
      projectIds: new FormControl(),
      userIds: new FormControl(),
      executionStatus: new FormControl(),
      location: new FormControl(),
      startDate: new FormControl(),
      endDate: new FormControl(),
      testCaseId: new FormControl(),
    });

    this.form.get('projectIds').disable();

    this.form.get('loadTestType').valueChanges.subscribe(val => {
      if (val) {
        this.form.get('projectIds').enable();
      } else {
        this.form.get('projectIds').disable();
      }
    })
  }

  getProjectRelatedData() {
    this.form.get('testCaseId').reset();
    this.form.get('userIds').reset();

    const projectId = this.form.get('projectIds').value;

    this.listNonfunctionTestcase();
    this.getUsersByProject(projectId);
  }

  getUserProject() {
    this.userService.getMyProjectList().subscribe(data => {
      if (data.code === 200) {
        this.userProjects = data.response;
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  listNonfunctionTestcase() {
    this.testCasesList = [];
    const projectId = this.projectIdsValue;
    const loadTestType = this.form.get('loadTestType').value;
    if (!projectId || projectId === undefined || !loadTestType) { return; }

    this.performanceService.getLoadTestingNFTC(projectId, loadTestType).subscribe(data => {
      if (data.code === 200) {
        this.testCasesList = data.response;
      } else {
        this.toastr.error('Fetch NF Test-Case Error: ' + data.message);
        this.testCasesList = [];
      }
    });
  }

  getUsersByProject(projectIds: string | any[]) {
    if (!projectIds || projectIds.length === 0) {
      this.form.controls.userIds.reset();
      return;
    }

    const projects = {
      projectIds
    };
    this.performanceService.getUsersByProject(projects).subscribe(data => {
      if (data.code === 200) {
        this.projectUsers = data.response;
      } else {
        this.projectUsers = [];
      }
    });
  }

  submitSearch() {
    this.queryParamsData.page = 1;
    this.queryParamsData.size = 15;
    const queryParamsData = {
      page: this.queryParamsData.page,
      size: this.queryParamsData.size,
      ...this.form.value
    }
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: queryParamsData });
  }

  getQueue(params?: any) {
    if (!params || params.projectIds == undefined) return;

    this.setParamsVal(params);

    const formValues = JSON.parse(JSON.stringify(this.form.value));
    delete formValues.loadTestType;

    const queryParamsData = {
      page: this.queryParamsData.page,
      size: this.queryParamsData.size,
      ...formValues
    }
    this.performanceService.getQueueList(queryParamsData).subscribe(data => {
      if (data.code === 200) {
        this.queueData = data.response;
        this.page = this.queryParamsData.page;
        if(this.queueData.performanceRequests.length < this.pageSize) this.moreData = false;
        else{
          this.moreData = true;
        }
      } else {
        // this.queueData = [];
        this.moreData = false;
        this.toastr.error(data.message);
      }
    });
  }

  resetApiType() {
    this.form.get('location').reset();
    this.queueData = null;

    this.setLocation();
    this.getProjectRelatedData();
  }

  clearFilter() {
    this.form.reset();
    this.queueData = null;

    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: { page: this.queryParamsData.page, size: this.queryParamsData.size }
    });
  }

  goToCompareResult() {
    if (!this.queueData) {
      this.toastr.error('Please select testname')
    }
    /* Get selected ids */
    const ids = this.queueData.performanceRequests
      .filter((item: { selected: any; }) => item.selected)
      .map((item) => item.id);
    this.getCompareResults(ids)
  }

  getCompareResults(ids: any) {
    var a = new Set();
    const id = ids.map((item) => {
      return { id: item };
    });
    
    this.performanceService.getCompareResults(this.form.value.testCaseId, id).subscribe((data) => {
      if (data.code === 200) {
        const results = data.response;
        results.forEach(i=>{a.add(i.performanceEndPointDtos.length)})
       if(a.size === 1){
        this.router.navigate(['performance/loadTesting/compare-results'],
        {state: {data : results}})
       } else{
        this.toastr.error('The number of associated endpoints in the selected testcases do not match')
       }
      }
    });
  }

  setEndDate(date) {
    var Date = this.convertDateToString(date);
    this.form.get('startDate').setValue(Date);
    this.form.get('endDate').reset();
    this.enddate = date;
  }

  setDate(date) {
    var Date = this.convertDateToString(date);
    this.form.get('endDate').setValue(Date);
  }

  convertDateToString(date) {
    var mon = date.month < 9 ? '0' + date.month : date.month;
    var day = date.day < 9 ? '0' + date.day : date.day;
    return (date.year + '-' + mon + '-' + day);
  }

  disableCompare() {
    return this.queueData.performanceRequests.filter((item: { selected: any; }) => item.selected).length;
  }

  setLocation() {
    if (this.form.get('loadTestType').value === "WEB") {
      this.locations = this.locations.filter(item => item === "OREGON")
    }
    if (this.form.get('loadTestType').value === "API") {
      this.locations = JSON.parse(localStorage.getItem('about')).executionLocations.map(loc => loc.location);
    }
  }

  loadMore(page){
    this.moreData = true;
    this.page = parseInt(page) + 1;
    this.queryParamsData.page = this.page;
    this.queryParamsData.size = this.pageSize;
    const formValues = JSON.parse(JSON.stringify(this.form.value));
    delete formValues.loadTestType;

    const queryParamsData = {
      page: this.queryParamsData.page,
      size: this.queryParamsData.size,
      ...formValues
    }
    this.performanceService.getQueueList(queryParamsData).subscribe(data => {
      if (data.code === 200) {
        data.response.performanceRequests.map(item => {this.queueData.performanceRequests.push(item)})
        if(data.response.performanceRequests.length < this.pageSize) {this.moreData = false;}
        else{
          this.moreData = true;
        }
      } else {
        this.moreData = false;
      }
    });

  }

  get projectIdsValue() {
    return this.form.get('projectIds').value;
  }

  get testCaseIdValue() {
    return this.form.get('testCaseId').value;
  }
}
